import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  LOGOUT_SUCCESS,
  LOGOUT_FAIL,
  SIGN_UP,
  SIGN_UP_SUCCESS,
  SIGN_UP_FAIL,
  SET_HEADERS,
  IS_REQUESTING_RESET,
  IS_REQUESTING_SUCCESS,
  SET_EMAIL_RESET_PASSWORD,
  CHANGING_PASSWORD,
  RESET_AUTH_STORE
} from '../mutationTypes'
import getLoginStoreDefaultState from '@/state/loginStore/loginStoreDefaultState'

export default {
  [SET_HEADERS](state, authHeaders) {
    state.auth = authHeaders
  },
  [LOGIN](state) {
    state.loggingIn = true
  },
  [LOGIN_SUCCESS](state) {
    state.isLoggedIn = true
    state.loggingIn = false
  },
  [LOGIN_FAIL](state) {
    state.isLoggedIn = false
    state.loggingIn = false
  },
  [LOGOUT](state) {
    state.isLoggedIn = false
  },
  [LOGOUT](state) {
    state.loggingOut = true
  },
  [LOGOUT_SUCCESS](state) {
    state.isLoggedIn = false
    state.loggingOut = false
  },
  [LOGOUT_FAIL](state) {
    state.isLoggedIn = true
    state.loggingOut = false
  },
  [SIGN_UP](state) {
    state.signingUp = true
  },
  [SIGN_UP_SUCCESS](state) {
    state.signingUp = false
    state.isSignedUp = true
  },
  [SIGN_UP_FAIL](state) {
    state.signingUp = false
    state.isSignedUp = false
  },
  [IS_REQUESTING_RESET](state, payload) {
    state.isRequestingReset = payload
  },
  [IS_REQUESTING_SUCCESS](state, payload) {
    state.isRequestingSuccess = payload
  },
  [SET_EMAIL_RESET_PASSWORD](state, payload) {
    state.userEmail = payload
  },
  [CHANGING_PASSWORD](state, payload) {
    state.changingPassword = payload
  },
  [RESET_AUTH_STORE](state) {
    Object.assign(state, getLoginStoreDefaultState())
  }
}
